const data = [
  { id: 0, name: 'Pendente de revisão' },
  { id: 1, name: 'Validado' },
  { id: 2, name: 'Alerta de incoerência' },
]

export default [...data]
